module.exports = __webpack_public_path__ + "static/paris-001.thumb-6e52ef768ff958a22e3323201f960abb.jpg";